import { Dialog, type DialogProps } from '@progress/kendo-react-dialogs'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { LabelingContainer } from '~/components/elements/LabelingContainer'
import { VStack } from '~/components/elements/VStack'

import { useCurrentSurveyGroup } from '../../hooks/useCurrentSurveyGroup'
import { useCurrentSurveys } from '../../hooks/useCurrentSurveys'

import { BrandCheckboxes } from './BrandCheckboxes'
import styles from './DisplayItemSettingsDialog.css'
import { SurveyCheckbox } from './SurveyCheckbox'

export type DisplayItemSettingsDialogProps = {
  onClose?: DialogProps['onClose']
}

export const DisplayItemSettingsDialog = ({
  onClose,
}: DisplayItemSettingsDialogProps) => {
  const { t } = useTranslation()
  const surveyGroup = useCurrentSurveyGroup()
  const surveys = useCurrentSurveys()

  return (
    <Dialog className={styles.root} title={t('select_data')} onClose={onClose}>
      <VStack spacing={4}>
        <LabelingContainer label={t('brand_name_7')} labelVariant="heading2">
          <VStack spacing={2}>
            {surveyGroup.brands.map((brand) => (
              <BrandCheckboxes key={brand.id} brand={brand} />
            ))}
          </VStack>
        </LabelingContainer>

        <LabelingContainer label={t('survey_2')} labelVariant="heading2">
          <VStack spacing={2}>
            {surveys.map((survey) => (
              <SurveyCheckbox key={survey.id} survey={survey} />
            ))}
          </VStack>
        </LabelingContainer>
      </VStack>
    </Dialog>
  )
}
